import { css } from 'linaria';
import { strictBreakpoints, breakpoints } from '../../../../../media';

export const serviceStyles = css`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	text-decoration: none;
	color: var(--text-primary);
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 9px 33px 0 rgb(0 0 0 / 3%), 0 2px 18px 0 rgb(0 0 0 / 4%),
		0 2px 10px 0 rgb(0 0 0 / 3%), 0 1.4px 5px 0 rgb(0 0 0 / 3%), 0 1.17px 2px 0 rgb(0 0 0 / 2%);

	span {
		padding: 24px;
	}

	img {
		min-height: 156px;
	}
	${strictBreakpoints.onlyMobile} {
		max-width: 204px;
		box-shadow: 0px 9px 33px 0px rgba(0, 0, 0, 0.03), 0px 2px 18px 0px rgba(0, 0, 0, 0.04),
			0px 2px 10px 0px rgba(0, 0, 0, 0.03), 0px 1.4px 5px 0px rgba(0, 0, 0, 0.03),
			0px 1.17px 2px 0px rgba(0, 0, 0, 0.02);
		span {
			padding: 24px 16px;
		}
	}
`;
export const serviceTypographyStyles = css`
	padding: 24px !important;
	${breakpoints.to.desktop} {
		padding: 24px 16px !important;
	}
`;
